import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=9b4909f8&"
import script from "./TestResult.vue?vue&type=script&lang=js&"
export * from "./TestResult.vue?vue&type=script&lang=js&"
import style0 from "./TestResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports